import React, { useState } from "react";
import CustomTable from "../../../../../components/table/table";
import "../style.css";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import CommonForm from "../../../../../components/commonform/commonForm";
import Snackbar from "../../../../../components/snackbar/snackbar";

export default function View(props) {
  const [agreeDeclaration1, setAgreeDeclaration1] = useState(false);
  const [agreeDeclaration2, setAgreeDeclaration2] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const handleEdit = () => {};
  const setAreaData = (data) => {
    let tdata = [];

    data.forEach((item) => {
      if (
        item.location_id !== null &&
        item.location_id !== "" &&
        item.location_id !== undefined
      ) {
        tdata.push(item);
      }
    });

    return tdata;
  };
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleCheckChangeDeclaration1 = (e) => {
    let checked = e.target.checked;
    setAgreeDeclaration1(checked);
  };
  const handleCheckChangeDeclaration2 = (e) => {
    let checked = e.target.checked;
    setAgreeDeclaration2(checked);
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.logout();
    }
  };

  const handleCheckDeclaration = () => {
    if (!agreeDeclaration1 || !agreeDeclaration2) {
      setSnackMessage("Please agree to both declarations before submitting.");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }
    props.action(4);
  };
  const getCompanyStatusLabel = (status) => {
    if (status === "new_company") return "New Company";
    if (status === "existing_company") return "Existing Company";
    return "";
  };
  return (
    <div className="demox">
      <div className="conti view-containe">
        <h6>
          <b>Basic Details</b>
        </h6>

        <hr />

        <div className="data">
          <div className="row">
            <div className="col-3">Company Name</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.company_name ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Contact Person Name</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.person_name ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Contact Person Designation</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.person_designation}</div>
          </div>
          <div className="row">
            <div className="col-3">Primary Mail Id</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.email ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Primary Contact No</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.mobile_number ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Website Link</div>
            <div className="col-1">:</div>
            <div className="col-7" style={{ overflowWrap: "break-word" }}>
              {props.basicData.site_link ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Address</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.address ?? ""}</div>
          </div>

          <div className="row">
            <div className="col-3">Alternate Contact No</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.alternate_phone && (
                <>
                  {props.basicData.country_code &&
                    props.basicData.country_code !== "" &&
                    props.basicData.country_code !== "undefined" &&
                    props.basicData.country_code !== "null" && (
                      <>
                        {props.basicData.country_code ?? ""}{" "}
                        {props.basicData.country_code &&
                        props.basicData.country_code !== ""
                          ? "-"
                          : ""}{" "}
                      </>
                    )}
                </>
              )}
              {props.basicData.alternate_phone ?? ""}
            </div>
          </div>

          <div className="row">
            <div className="col-3">Alternate Mail Id</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.alternate_email ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">
              Are you a New Company / Existing Company
            </div>
            <div className="col-1">:</div>
            <div className="col-7">
              {getCompanyStatusLabel(props.basicData.company_status)}
            </div>
          </div>
          {props.basicData.company_status === "existing_company" && (
            <>
              {Array.isArray(props.basicData.financial_records) && props.basicData.financial_records.length > 0 ? (
                <>
                  {props.basicData.financial_records.map((fr, i) => (
                    <div className="row" key={`fr-${i}`}>
                      <div className="col-3">Previous Financial Year {props.basicData.financial_records.length > 1 ? `(${i + 1})` : ""}</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        <div>{fr.financial_year || ""}</div>
                        <div className="text-muted small">Turnover (in Lakhs): {fr.fy_turnover || ""}</div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  <div className="row">
                    <div className="col-3">Previous Financial Year</div>
                    <div className="col-1">:</div>
                    <div className="col-7">{props.basicData.financial_year ?? ""}</div>
                  </div>
                  <div className="row">
                    <div className="col-3">Previous Financial Year Turnover</div>
                    <div className="col-1">:</div>
                    <div className="col-7">{props.basicData.fy_turnover ?? ""}</div>
                  </div>
                </>
              )}
            </>
          )}
          <div className="row">
            <div className="col-3">Capital Investment Expected in Crores</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.capital_investment ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3"> Initial Direct Employment </div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.ex_man_power ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Abstract Project Proposal</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.abstract_project_proposal ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Product Profile</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData?.product_profiles?.map((item) => (
                <>
                  <div className="col-12 mb-1">
                    <b>{item.product_name ?? ""}</b>
                  </div>
                  <div className="col-12 mb-1 ">
                    {" "}
                    <div>{ReactHtmlParser(item.product_desc)}</div>
                  </div>
                </>
              ))}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Domain Type</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData?.domain_types && (
                <>
                  {props.basicData?.domain_types?.map((dom, i) => (
                    <div>{dom.domain_name} </div>
                  ))}
                </>
              )}
              {(props.basicData?.any_other_flag === "1" ||
                props.basicData?.any_other_flag) && (
                <div>{props.basicData?.any_other_domain}</div>
              )}
            </div>
          </div>

          {props.update === true &&
          typeof props?.basicData?.upload_proposal === "string" ? (
            <div className="row">
              <div className="col-3 field-titles">Document Uploaded</div>
              <div className="col-1 hideonMobile">:</div>
              <div className="col-7">
                <a
                  onClick={() => {
                    window.open(
                      `${result}${props?.basicData?.upload_proposal}`,
                      "_blank"
                    );
                  }}
                  className="detailFile"
                >
                  View
                </a>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-3 ">Document Uploaded</div>
              <div className="col-1 ">:</div>
              <div className="col-7">{props?.basicData?.file_name}</div>
            </div>
          )}
          <div className="row">
            <div className="col-3 ">Logo Uploaded</div>
            <div className="col-1 ">:</div>
            <div className="col-7">{props?.basicData?.logo_name}</div>
          </div>

          {/* <div className="row">
            <div className="col-3">Document Uploaded</div>
            <div className="col-1">:</div>
            <div className="col-7 ">{props.basicData?.file_name}</div>
          </div> */}
        </div>
        <h6>
          <b>Area Requirements</b>
        </h6>

        <hr />
        <div className="data">
          {props.basicData.area_type === "built_up_space" && (
            <div className="row pb-3">
              <div className="col-3 mb-2">Built-up space on Rent per Month</div>
              <div className="col-1">:</div>
              <div className="col-8 ">
                <CustomTable
                  className="areatable"
                  {...props}
                  columns={[
                    { title: "Preference No", field: "id", type: "dynId" },
                    { title: "Location", field: "location" },
                    { title: "Sub Location", field: "sub_location" },
                    { title: "Area Type", field: "built_space_type_name" },
                    {
                      title: "Requested Area Requirement",
                      field: "area_in_sqft",
                    },
                  ]}
                  data={setAreaData(props.basicData?.area_management)}
                />
              </div>
            </div>
          )}
          {props.basicData.area_type === "equipped_facility" && (
            <div className="row pb-3">
              <div className="col-3 mb-2">Equipped Facility per Month </div>
              <div className="col-1">:</div>
              <div className="col-7">
                <CustomTable
                  className="areatable"
                  {...props}
                  columns={[
                    { title: "Preference No", field: "id", type: "dynId" },
                    { title: "Location", field: "location" },
                    {
                      title: "Requested Area Requirement",
                      field: "area_in_sqft",
                    },
                  ]}
                  data={setAreaData(props.basicData?.area_management)}
                />
              </div>
            </div>
          )}
          {props.basicData.area_type === "land_on" && (
            <div className="row pb-3">
              <div className="col-3 mb-2">Land on Lease </div>
              <div className="col-1">:</div>
              <div className="col-8">
                <CustomTable
                  className="areatable"
                  {...props}
                  columns={[
                    { title: "Preference No", field: "id", type: "dynId" },
                    { title: "Location", field: "location" },
                    { title: "Sub Location", field: "sub_location" },
                    // { title: "Area  in Acres", field: "area_in_acres" },
                    {
                      title: "Requested Area Requirement",
                      field: "area_in_sqft",
                    },
                    { title: "Years", field: "lease_year" },
                  ]}
                  data={setAreaData(props.basicData?.area_management)}
                />
                {console.log(props.basicData?.area_management)}
              </div>
            </div>
          )}
          {props.basicData.area_type === "joint_venture" && (
            <div className="row pb-3">
              <div className="col-3 mb-2">Joint Venture</div>
              <div className="col-1">:</div>
              <div className="col-8 venure">
                <CustomTable
                  className="areatable"
                  {...props}
                  columns={[
                    { title: "Preference No", field: "id", type: "dynId" },
                    { title: "Location", field: "location" },
                    { title: "Sub Location", field: "sub_location" },
                    { title: "Category", field: "category" },
                    { title: "Area Type", field: "built_space_type_name" },
                    { title: "Requirement", field: "area_in_sqft" },
                    { title: "Lease Years", field: "lease_year" },
                    { title: "Investment Model", field: "investment_model" },
                    { title: "Management Plan", field: "management_plan" },
                  ]}
                  data={setAreaData(props.basicData?.area_management)}
                />
                {/* {props.basicData?.area_management?.map((item) => (
                  <>
                    {item.location_id !== null &&
                      item.location_id !== "" &&
                      item.location_id !== undefined && (
                        <div className="row venture">
                          <div className="col-12 mb-1">
                            <label>Location&nbsp;:&nbsp;</label>
                            <b>{item.location}</b>
                          </div>
                          <div className="col-12 mb-1 text-justify">
                            <label>Area&nbsp;:&nbsp;</label>
                            <b>{item.area_in_sqft}</b>
                          </div>
                          <div className="col-12 mb-1 text-justify">
                            <label>Investment Model&nbsp;:&nbsp;</label>
                            <b> {item.investment_model}</b>
                          </div>
                          <div className="col-12 mb-1 text-justify">
                            <label>Management Plan&nbsp;:&nbsp;</label>
                            <b> {item.management_plan}</b>
                          </div>
                          <div className="col-12 mb-1 text-justify">
                            <label>Area Type&nbsp;:&nbsp;</label>
                            <b> {item.area}</b>
                          </div>
                          <div className="col-12 mb-1 text-justify">
                            <label>Address&nbsp;:&nbsp;</label>
                            <b> {item.land_address}</b>
                          </div>
                        </div>
                      )}
                  </>
                ))} */}
              </div>
            </div>
          )}
          {props.basicData.area_type === "own_land" && (
            <div className="row pb-3">
              <div className="col-3 mb-2">Own Premises </div>
              <div className="col-1">:</div>
              <div className="col-8">
                <CustomTable
                  className="areatable"
                  {...props}
                  columns={[
                    { title: "Location", field: "location" },
                    { title: "Available Area", field: "area_in_sqft" },
                    // { title: "Land Address", field: "land_address" },
                    // { title: "Available Area", field: "area" },
                    { title: "Nature Of Holding", field: "nature_of_holding" },
                    { title: "Survey Number", field: "survey_no" },
                    { title: "Block Number", field: "block_no" },
                    { title: "Village Name", field: "village_name" },
                  ]}
                  data={setAreaData(props.basicData?.area_management)}
                />
              </div>
            </div>
          )}
        </div>
        <div className="d-flex pt-3">
          <div>
            <center>
              <CommonForm
                fieldType="checkbox"
                value={agreeDeclaration1}
                required
                checked={agreeDeclaration1}
                onChange={(e) => handleCheckChangeDeclaration1(e)}
                label=""
                {...props}
              />
            </center>
          </div>
          <div className="mt-1">
            I hereby, declare that the entries made by me in the form are
            complete and true to the best of my knowledge and based on records
          </div>
        </div>
        <div className="d-flex pt-3">
          <div>
            <center>
              <CommonForm
                fieldType="checkbox"
                value={agreeDeclaration2}
                required
                checked={agreeDeclaration2}
                onChange={(e) => handleCheckChangeDeclaration2(e)}
                label=""
                {...props}
              />
            </center>
          </div>
          <div className="mt-1">
            I hereby agree to use the company's name & logo in the promotional
            activities of Kerala spacepark
          </div>
        </div>

        <div className="footer-buttons">
          <div
            className="secondary-btn"
            onClick={(e) => {
              props.action(3, props);
            }}
          >
            GO BACK
          </div>
          <div
            className="primary-btn"
            // onClick={(e) => {
            //   // props.action(4);
            //   handleCheckDeclaration(e)
            // }}
            onClick={handleCheckDeclaration}
          >
            REGISTER
          </div>
        </div>
      </div>
      {snackOpen && (
        <Snackbar
          message={snackMessage}
          error={isSnackError}
          open={snackOpen}
          close={snackbarClose}
        />
      )}
    </div>
  );
}
